import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/38.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Stary Tornau przypływa na pomoc"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Dalej",
        }}
        links={{
            link1: PAGES.p65,
        }}
        content={
            <div>
                <ul>
                    <li>Płyniemy? – uśmiecha się stary Tornau, patrząc na Stefana. Ten gest dobroci wyraźnie zawstydza gęsiarza, ale nie na tyle, żeby nie skorzystać z okazji.</li>
                    <li>Dziękuję, dobrodzieju, taką gąskę z jabłkami panu upichcę w podzięce, że palce lizać!
                    </li>
                    <li>Ha! Muszę odmówić. Nie mógłbym zjeść przyjaciela… Wsiadajcie! Płyniemy na Święto Dyszla.</li>
                </ul>
            </div>
        }
        />
        
            );
}